import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Table, Button, Card, CardHeader, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import _ from "lodash";

import DefaultDataGrid from "modules/5_view_helpers/web/DefaultDataGrid";
import columns from "./columns";

// Helpers
import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";

// Actions
import { getProjectQaWeldingInspectionsFilletSizes } from "../actions";

function mapStateToProps(state) {
  return {
    project_qa_welding_inspections_fillet_sizes: state.project_qa_welding_inspections_fillet_sizes,
  };
}

const ProjectQaWeldingInspectionsFilletSizesIndex = (props) => {
  useEffect(() => {
    props.getProjectQaWeldingInspectionsFilletSizes();
  }, []);

  const { project_qa_welding_inspections_fillet_sizes } = props;

  const readRole = HasRole({ resource_type: "Project::Qa::WeldingInspections::FilletSize", name: ["read", "moderator"] });
  const createRole = HasRole({ resource_type: "Project::Qa::WeldingInspections::FilletSize", name: ["create", "moderator"] });
  const updateRole = HasRole({ resource_type: "Project::Qa::WeldingInspections::FilletSize", name: ["update", "moderator"] });

  if (!readRole) {
    return <NotAuthorized />;
  } else {
    return (
      <Card>
        <CardHeader>
          <Row>
            <Col>
              <h3>Fillet sizes</h3>
            </Col>
          </Row>
        </CardHeader>

        <CardBody>
          {createRole && (
            <Row>
              <Col>
                <Link to={`/project/qa/welding_inspections/fillet_sizes/new`}>
                  <Button color="primary" size="md">
                    <i className="fa fa-plus"> Create New Fillet size</i>
                  </Button>
                </Link>
              </Col>
            </Row>
          )}

          <Row className="mt-2">
            <Col>
              <DefaultDataGrid columns={columns(updateRole)} data={project_qa_welding_inspections_fillet_sizes} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }
};
export default connect(mapStateToProps, { getProjectQaWeldingInspectionsFilletSizes })(ProjectQaWeldingInspectionsFilletSizesIndex);
